module.exports = __webpack_public_path__ + "img/arrow-right.31cc0f4d.svg";